import { render, staticRenderFns } from "./MexUbicaciones.vue?vue&type=template&id=651df5fa"
import script from "./MexUbicaciones.vue?vue&type=script&lang=js"
export * from "./MexUbicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports